import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export const Section = ({ title, kicker, children, className = "" }) => (
  <section className={`bg-white border border-slate-200 rounded-lg p-5 sm:p-6 sr-rise ${className}`}>
    {kicker && <div className="text-xs font-tech uppercase tracking-wider text-[#0F52BA] mb-1">{kicker}</div>}
    {title && <h2 className="text-base md:text-lg font-display font-semibold text-slate-900 mb-4">{title}</h2>}
    {children}
  </section>
);

export const Field = ({ label, hint, children }) => (
  <div className="space-y-1.5">
    <Label className="text-sm text-slate-700">{label}</Label>
    {children}
    {hint && <p className="text-xs text-slate-500">{hint}</p>}
  </div>
);

export const NumField = ({ label, value, onChange, unit, step = "any", testid, hint, min }) => (
  <Field label={label} hint={hint}>
    <div className="relative">
      <Input
        type="number" inputMode="decimal" step={step} min={min} value={value ?? ""} data-testid={testid}
        onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className="h-11 pr-14 font-tech"
      />
      {unit && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-400 font-tech">{unit}</span>}
    </div>
  </Field>
);

export const SidePanel = ({ children, testid }) => (
  <aside data-testid={testid} className="w-full lg:w-[380px] shrink-0 bg-white border-l border-slate-200 overflow-y-auto p-5 space-y-6 max-h-[45vh] lg:max-h-none">
    {children}
  </aside>
);

export const PanelTitle = ({ children }) => (
  <div className="text-xs font-tech uppercase tracking-wider text-slate-500 mb-3">{children}</div>
);

export const Metric = ({ label, value, testid }) => (
  <div className="bg-slate-50 border border-slate-200 rounded-md p-3">
    <div className="text-[11px] font-tech uppercase tracking-wider text-slate-500">{label}</div>
    <div className="font-display font-semibold text-slate-900 text-lg" data-testid={testid}>{value}</div>
  </div>
);
